import { apiWithToken } from '../api';

const resouceUrl = '/ods/metas';
const token = localStorage.getItem('@token');
let api = apiWithToken(token);

export const load_metas_ods = async (objetivo_id, params) => {
    return await api.get(`${resouceUrl}/objetivos_metas/${objetivo_id}`, {
        params: { ...params}
    });
}
